import { GRAAL_API_URL } from "../../config";
import useStore from "../../context/useStore";
import { graalApiAxiosInstance } from "../../middlewares/useApiAuthMiddleware";

const useLeadAutoCommentService = () => {
  const [state] = useStore();

  const leadAutoCommentServiceActions = {
    postComment: (leadId, commentData) => {
      return graalApiAxiosInstance
        .post(`${GRAAL_API_URL}new-leads/${leadId}/ajouter-commentaire`, {
          contenu: commentData.contenu,
          creePar: state.auth.user.id,
          utilisateursMentionnes: commentData.utilisateursMentionnes || [],
        })
        .then((res) => res.data);
    },
    patchComment: (leadId, commentId, commentData) => {
      return graalApiAxiosInstance
        .put(`${GRAAL_API_URL}new-leads/${leadId}/modifier-commentaire`, {
          id: commentId,
          contenu: commentData.contenu,
          modifiePar: state.auth.user.id,
          utilisateursMentionnes: commentData.utilisateursMentionnes || [],
        })
        .then((res) => res.data);
    },
    deleteComment: (leadId, commentId) => {
      return graalApiAxiosInstance
        .delete(
          `${GRAAL_API_URL}new-leads/${leadId}/supprimer-commentaire/${commentId}`,
        )
        .then((res) => res.data);
    },
  };

  return { leadAutoCommentServiceActions };
};

export default useLeadAutoCommentService;
